"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
//import { DialogYesNoController } from "../../controllers/dialogs/YesNoDialogController";
var antd_1 = require("antd");
var DlgYesNo = /** @class */ (function (_super) {
    __extends(DlgYesNo, _super);
    function DlgYesNo(props) {
        return _super.call(this, props) || this;
    }
    DlgYesNo.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                title: data.title,
                message: data.message
            });
        });
        this.setState({
            visible: this.props.controller.DATA.visible,
            title: this.props.controller.DATA.title,
            message: this.props.controller.DATA.message
        });
    };
    DlgYesNo.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgYesNo.prototype.handleNo = function () {
        this.props.controller.Close();
        if (this.props.controller.OnNo) {
            this.props.controller.OnNo();
        }
    };
    DlgYesNo.prototype.handleYes = function () {
        this.props.controller.Close();
        if (this.props.controller.OnYes) {
            this.props.controller.OnYes();
        }
    };
    DlgYesNo.prototype.render = function () {
        return (React.createElement(antd_1.Modal, { title: this.state.title, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleNo.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false },
            React.createElement("p", null, this.state.message)));
    };
    return DlgYesNo;
}(React.Component));
exports.default = DlgYesNo;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgYesNo.tsx
// module id = 1721
// module chunks = 0